export default "__VITE_ASSET__Bx23QAbS__"